export const USER_ROLES = [
  {
    label: 'Admin',
    value: 'admin',
  },
  {
    label: 'Employee',
    value: 'employee',
  },
]

export const USER_STATES = [
  {
    label: 'Approved',
    value: 'Approved',
  },
  {
    label: 'Pending',
    value: 'Pending',
  },
]

export const PERMITTED_USER_CREATION_TYPES = {
  admin: [
    {
      label: 'Shipper',
      value: 'shipper',
    },
    {
      label: 'Owner Operator',
      value: 'owner_operator',
    },
    {
      label: 'Dispatcher',
      value: 'dispatcher',
    },
    {
      label: 'Driver',
      value: 'driver',
    },
    {
      label: 'Admin',
      value: 'admin',
    },
  ],
  carrier: [
    {
      label: 'Owner Operator',
      value: 'owner_operator',
    },
    {
      label: 'Dispatcher',
      value: 'dispatcher',
    },
    {
      label: 'Driver',
      value: 'driver',
    },
  ],
  shipper: [
    {
      label: 'Shipper',
      value: 'shipper',
    },
  ],
}

export const USER_ROLE_DESCRIPTION: { [key: string]: string } = {
  employee: "Has full access to everything but can't create new users.",
  admin: 'Has full access to everything and can create new users for their organization.',
}
